import { flow } from '../../../../../../util/flow';
import { codePen } from './codepen';
import { codeSandBox } from './codeSandBox';
import { githubGist } from './githubGist';
import { iframeLink } from './iframeLink';
import { replit } from './replit';
import { runKit } from './runKit';

export const embedCodingHandler = flow(
  codeSandBox,
  codePen,
  replit,
  githubGist,
  runKit,
  iframeLink,
);
